

















































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { formatCurrency } from "@/shared/currency";
import * as Routes from "@/employee/route-names";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { DrivewealthAccountSummary, DrivewealthAccountManagementType } from "@/shared/types";
import _ from "lodash";
import * as SharedRoutes from "@/shared/route-names";
import moment from "moment/moment";

@Component({
  components: { GenericLoadingSpinner }
})
export default class DrivewealthInvestmentAccountList extends Vue {
  drivewealthStore = useDrivewealthStore();
  featureFlagStore = useFeatureFlagStore();
  custodianSettingsStore = useCustodianSettingsStore();

  SharedRoutes = SharedRoutes;
  DrivewealthAccountManagementType = DrivewealthAccountManagementType;
  formatCurrency = formatCurrency;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  load (): void {
    this.drivewealthStore.loadAccountSummariesV2({
      username: this.username,
      partnerId: this.partnerId,
    });
  }

  mounted (): void {
    this.load();
  }

  get isLoaded (): boolean {
    return this.drivewealthStore.accountSummariesV2Loaded;
  }

  get accountSummaries (): DrivewealthAccountSummary[] {
    return this.drivewealthStore.accountSummariesV2;
  }

  get hasInvestmentAccounts (): boolean {
    return this.accountSummaries.length > 0;
  }

  get formattedDateNow (): string {
    return moment().format("MMM DD");
  }

  accountIconForAccountType (accountManagementType: DrivewealthAccountManagementType): string {
    switch (accountManagementType) {
      case DrivewealthAccountManagementType.RiaManaged:
        return "fa-light fa-handshake";
      case DrivewealthAccountManagementType.Advisory:
        return "fa-sliders";
      case DrivewealthAccountManagementType.OpenBrokerage:
        return "fa-list-check";
      default:
        return "fa-list-check";
    }
  }
}
